import { Typography } from '@mui/material'
import Grid from '@mui/material/Grid'
import IconsList from 'common/constants/icons_map'

const MenuIconsList = () => {
  return (
    <Grid container spacing={2} sx={{ maxWidth: '1200px', margin: '0 auto', p: 2 }}>
      {Object.entries(IconsList).map(([key, IconComponent]) => (
        <Grid
          size={2}
          key={key}
          sx={{
            m: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconComponent style={{ fontSize: 40 }} />
          <Typography>{key}</Typography>
        </Grid>
      ))}
    </Grid>
  )
}

export default MenuIconsList
